import { useMemo } from 'react'

import { AgChartOptions } from 'ag-charts-community'

import { cn } from '@fortem-monorepo/js-utilities'
import { CustomAgChart } from '@fortem-monorepo/react-ag'
import { ICReport } from '@fortem-monorepo/web-sdk'

import { perIssuerItemStyler } from '@/pages/funds/ic-report/components/primitives/charts/per-issuer-styler'
import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { income } from '@/react-query/queries/ic-report/hooks'

type PerIssuerNotionalData = ICReport.GetPerIssuerData['per_issuer_notional']
type PerIssuerNotionalItem = PerIssuerNotionalData[string][number]

export interface PerIssuerNotionalChartsProps extends ICReportChartPrimitive {}

export const PerIssuerNotionalCharts: React.FC<PerIssuerNotionalChartsProps> = ({
  params,
  options,
}) => {
  const query = income.usePerIssuer(params)
  const data = query.data

  const charts = Object.entries(data?.per_issuer_notional ?? {})

  return (
    <div
      className={cn('grid', {
        ['grid-cols-2']: charts.length === 2,
      })}
    >
      {charts.map(([key, values]) => {
        return <PerIssuerNotionalChart title={key} data={values} options={options} />
      })}
    </div>
  )
}

interface PerIssuerNotionalChartProps {
  title: string
  data: PerIssuerNotionalData[string]
  options: ICReportChartPrimitive['options']
}

export const PerIssuerNotionalChart: React.FC<PerIssuerNotionalChartProps> = ({
  title,
  data,
  options,
}) => {
  const formattedData = useMemo(() => {
    return data.map((item) => {
      return {
        ...item,
        position_notional_base: parseFloat((item.position_notional_base / 1_000_000).toFixed(1)),
      }
    })
  }, [data])

  const mergedOptions: AgChartOptions<PerIssuerNotionalItem> = {
    data: formattedData,
    title: {
      text: `${title} Notional (mm)`,
    },
    series: [
      {
        type: 'pie',
        angleKey: 'position_notional_base',
        legendItemKey: 'product_issuer',
        calloutLabelKey: 'position_notional_base',
        calloutLabel: {
          formatter: (data) => {
            return `${data.value}`
          },
        },
        itemStyler: perIssuerItemStyler,
      },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
